import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';

function Videos() {
  return (
    <>
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-white transition">
      <Navbar />
      <div className="pt-24 px-6 max-w-5xl mx-auto">
        <br />
        <h2 className="text-2xl font-bold mb-6">Featured Videos</h2>
        <motion.div className="grid md:grid-cols-2 gap-6">
        <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Red Hat Enterprise Linux 9 (From Zero To Hero!)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/5UF37H3fwEY"
            title="Linux Red Hat Enterprise RHEL 9 (From Zero To Hero Full Course)"
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Rocky Enterprise Linux 9 (From Zero To Hero!)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/WrItyCWtCFM"
            title="YouTube video"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Mastering Visual Studio Code</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/9sed9X2zqY8"
            title="Mastering VS Code"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Python + R + MySQL + SQL on One Video</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/94AIzSI6EJI"
            title="Python, R, MySQL and SQL on One Video"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Anaconda on Red Hat Enterprise Linux 9</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/UJf0CyG62M8"
            title="Anaconda on RHEL9"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">How To Share PDF Files on YouTube</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/PXcgd33hLeE"
            title="Share PDF Files on YouTube"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">The Complete Course To BASH Shell Scripting</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/PfSWC3CVMp0"
            title="The Complete Course to BASH Shell Scripting"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Learn Advanced Level Linux Chapter 4 Part 8 of 8</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/DfQQb8QJh-A"
            title="Learn Advanced Level Linux Chapter 4 Part 8 of 8"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
        </motion.div>

          <iframe
            className="w-full aspect-video rounded-lg shadow-lg"
            src="https://www.MyWebUniversity.com/youtube-channels1w.html" 
            title="MyWebUniversity"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          </div>
    </>
  );
}
export default Videos;
